import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import mainPhoto from '../../images/gcse/main.jpeg';
import meeting1 from '../../images/gcse/meeting1.jpeg';
import meeting2 from '../../images/gcse/meeting2.jpeg';
import meeting3 from '../../images/gcse/meeting3.jpeg';
import meeting4 from '../../images/gcse/meeting4.jpeg';
import './BreakingNews.css';

// Hidden page: it is NOT in the menu. It is reached from the home page strip and the card at the top
// of Media & News (see the route in App.js).
export const BREAKING_NEWS_PATH = '/about-us/st-marys-in-media-and-news/breaking-news';

// Main picture, also used as the card thumbnail in Media & News
export const BREAKING_NEWS_IMAGE = mainPhoto;

// Article content in order. Texts are keys in locales/en/translations.json (breaking_*).
//  { text: key }   normal paragraph
//  { quote: key }  highlighted quote
//  { images: [] }  two pictures side by side
const BLOCKS = [
  { text: 'breaking_p1' },
  { text: 'breaking_p2' },
  { text: 'breaking_p3' },
  { images: [meeting1, meeting2] },
  { quote: 'breaking_q1' },
  { text: 'breaking_p4' },
  { text: 'breaking_p5' },
  { text: 'breaking_p6' },
  { quote: 'breaking_q2' },
  { text: 'breaking_p7' },
  { images: [meeting3, meeting4] },
  { quote: 'breaking_q3' },
];

function BreakingNews() {
  const { t } = useTranslation();

  return (
    <div className="breakingPage">
      <span className="breakingBadge">{t('breaking_label')}</span>
      <h1 className="breakingPageTitle">{t('breaking_headline')}</h1>
      <p className="breakingDateline">{t('breaking_dateline')}</p>
      <img className="breakingImage" src={mainPhoto} alt="" />

      {BLOCKS.map((block, index) => {
        if (block.images) {
          return (
            <div className="breakingGallery" key={index}>
              {block.images.map((src) => (
                <img src={src} alt="" key={src} loading="lazy" />
              ))}
            </div>
          );
        }
        if (block.quote) {
          return <blockquote className="breakingQuote" key={index}>{t(block.quote)}</blockquote>;
        }
        return <p key={index}>{t(block.text)}</p>;
      })}

      <Link to="/about-us/st-marys-in-media-and-news" className="breakingBack">
        {t('breaking_back')}
      </Link>
    </div>
  );
}

export default BreakingNews;
